import styled from "styled-components";
import { Orange, spanMaker, Text } from "../../../styledCpns/DataDisplay";
import { Box } from "../../../styledCpns/Layout";
import { ModalLayout } from "../../CommonCpns/Modal";

export const LesserSpan = spanMaker("#BFBDBC");

export const Lesser = ({ className, ...rest }) => (
  <Text
    className={"pt-1 " + (className || "")}
    color="#BFBDBC"
    lineHeight={1.6}
    {...rest}
  />
);

export const TrackerModal = styled(ModalLayout)`
  z-index: ${(pr) => (pr.state === 1 ? 10 : -1)};
`;

export const Columns = styled.div`
  columns: 1;
  & > div {
    padding-top: 0.5rem;
    page-break-inside: avoid; /* works on Chrome */
    break-inside: avoid-column;
    display: table;
  }
  @media (min-width: 769px) {
    padding-left: 1rem;
    columns: 2;
  }
`;

export const Divider = ({
  className = "my-4 mx-auto",
  width = "50%",
  bgColor = "gray"
}) => (
  <Box className={className} width={width} height="1px" bgColor={bgColor} />
);

export const heading = (white, orange) => (
  <Text bold>
    {white} <Orange b>{orange}</Orange>
  </Text>
);

export const noContent = (
  <Box className="pt-8 pb-4 flex-center" height="2rem">
    <Text variant="h5" color="gray">
      No content
    </Text>
  </Box>
);

export const error = (
  <Text className="mt-1" color="lightRed">
    This line indicates the tracker has done something wrong!
  </Text>
);
